import React, { useEffect, useState } from 'react';
import { Card } from 'reactstrap';
import { ReactComponent as CloseIcon } from "assets/img/svg/CrossIcon.svg";
import AInput from 'views/pages/manage/common/formFeilds/customInput/AInput';
import styles from "./style.module.css";
import { ReactComponent as UploadIcon } from "assets/img/svg/upload.svg";
import DocUploadModal from 'views/pages/manage/unAssigned/studentCharges/studentChargesDetails/paymentMode/DocUploadModal';
import AAutoComplete from 'views/pages/manage/common/form-fields-mui/AAutoComplete';
import { Label } from 'reactstrap';
import { InputLabelStyle } from 'views/pages/manage/common/form-fields-mui/ASelect';
import { getDropdowns, initialConfigForm } from './helper';
import AButton from 'views/pages/manage/common/form-fields-mui/AButton';
import { failureToast } from 'services/http';
import { ReactComponent as DonloadIcon } from "assets/img/svg/downloadBlackV2.svg";
import { ReactComponent as EditIcon } from "assets/img/svg/Edit2.svg";
import { ReactComponent as PdfIcon } from "assets/img/svg/pdfIcon.svg"
import { downloadFileByS3Key } from 'views/pages/manage/edpOps/studentDetails/paymentSummary/viewInvoice/ViewInvoicesDialog';

const CourseMappingConfiguration = ({ open = true, action, saveConfigHandler, configForm, dropdowns }) => {
    const [isUploadOpen, setIsUploadOpen] = useState(false);
    const [tempConfigForm, setTempConfigForm] = useState({});

    const [mode, setMode] = useState("idle");
    // "idle" | "view" | "edit" | "add"

    const isDealTypeMandatory = true;

    const hasConfig = !!configForm?.dealType;
    const isEditable = mode === "edit" || mode === "add";

    const configFormHandler = (key, value) => {
        key == "dealType" ?
            setTempConfigForm((prev) => ({
                ...prev, ...initialConfigForm, dealType: value,

            })) :
            setTempConfigForm((prev) => ({
                ...prev,
                [key]: value
            })
            );
    };


    useEffect(() => {
        debugger
        setTempConfigForm(configForm || {});
        if (configForm?.dealType) {
            setMode("view");
        } else {
            setMode("idle"); // ✅ new state (nothing shown)
        }
    }, [configForm]);

    const isB2B = tempConfigForm?.dealType?.label === "B2B";
    const isB2C = tempConfigForm?.dealType?.label === "B2C";

    const addNewConfigHandler = () => {
        if (hasConfig) {
            failureToast("Only one configuration allowed.");
            return;
        }
        setTempConfigForm({});
        setMode("add"); // 👈 form appears now
    };
    const editHandler = () => {
        setMode("edit");
    };

    const deleteHandler = () => {
        setTempConfigForm({});
        setMode("add");
        saveConfigHandler({});
    };

    const saveHandler = () => {
        if (!saveConfigHandler(tempConfigForm))
            return;
        setMode("view");
    };

    return (

        <Card className='p-3 mb-3'>
            <div className="d-flex justify-content-between align-items-center">
                <div>Course Mapping Configuration</div>

                {action != 'view' && mode === "idle" && (
                    <AButton variant="primary_filled" onClick={addNewConfigHandler}>
                        Add Configuration
                    </AButton>
                )}

                {action != 'view' && mode === "view" && (
                    <AButton variant="primary_filled" onClick={editHandler}>
                        Edit
                    </AButton>
                )}
            </div>
            {(mode === "add" || mode === "edit" || mode === "view") && (


                <div>
                    <div className='d-flex gap-2 m-3 flex-wrap'>

                        {/* Deal Type */}
                        <AAutoComplete
                            label={`Deal Type ${isDealTypeMandatory ? "*" : ""}`}
                            placeholder="Select deal type"
                            currentValue={tempConfigForm?.dealType}
                            handleChange={(value) => configFormHandler("dealType", value)}
                            items={dropdowns?.dealType || []}
                            isMulti={false}
                            isShowCount={false}
                            isDisabled={!isEditable}
                            style={{ control: { height: "47px", width: '220px' } }}
                        />

                        {/* Upload */}
                        {/* Upload Agreement Copy */}
                        {(isB2B || isB2C) && (
                            <div style={{ width: "220px" }}>
                                <Label style={InputLabelStyle}>{`Upload Agreement Copy${isB2C?'*':''}`}</Label>

                                {tempConfigForm?.agreementFileName ? (
                                    <div
                                        className="d-flex align-items-center justify-content-between px-2"
                                        style={{
                                            height: "47px",
                                            border: "1px solid #cdcccc",
                                            borderRadius: "6px",
                                            gap: "8px",
                                        }}
                                    >
                                        {/* Left Side */}
                                        <div
                                            className="d-flex align-items-center"
                                            style={{
                                                gap: "8px",
                                                flex: 1,
                                                overflow: "hidden",
                                            }}
                                        >
                                            <PdfIcon height={22} width={18} />

                                            <span
                                                className="regular-large-bold label-color"
                                                style={{
                                                    whiteSpace: "nowrap",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                }}
                                            >
                                                {tempConfigForm?.agreementFileName}
                                            </span>
                                        </div>

                                        {/* Right Side */}
                                        <div className="d-flex align-items-center" style={{ gap: "8px" }}>
                                            {/* Download in View Mode */}
                                            {mode === "view" && (
                                                <DonloadIcon
                                                    width="22px"
                                                    height="22px"
                                                    className="cursor"
                                                    onClick={() =>
                                                        downloadFileByS3Key(tempConfigForm?.agreementFilePath)
                                                    }
                                                />
                                            )}

                                            {/* Edit in Edit/Add Mode */}
                                            {isEditable && (
                                                <>
                                                    <EditIcon
                                                        className="cursor"
                                                        onClick={() => setIsUploadOpen(true)}
                                                    />
                                                    <CloseIcon
                                                        className="cursor"
                                                        onClick={() =>
                                                            setTempConfigForm((prev) => ({
                                                                ...prev,
                                                                agreementFilePath: "",
                                                                agreementFileName: "",
                                                            }))
                                                        }
                                                        style={{ width: "18px", height: "18px" }}
                                                    />
                                                </>
                                            )}
                                        </div>
                                    </div>
                                ) : (
                                    <div
                                        className="d-flex align-items-center justify-content-center  cursor"
                                        style={{
                                            height: "47px",
                                            border: "1px solid #cdcccc",
                                            borderRadius: "6px",
                                            gap: "8px",
                                            cursor: isEditable ? "pointer" : "not-allowed",
                                            opacity: isEditable ? 1 : 0.6,
                                        }}
                                        onClick={() => isEditable && setIsUploadOpen(true)}
                                    >
                                        <UploadIcon />
                                        <span>Upload</span>
                                    </div>
                                )}
                            </div>
                        )}

                        {/* B2B Fields */}
                        {isB2B && (
                            <>
                                <div>
                                    <AInput
                                        label="Minimum Guarantee *"
                                        value={tempConfigForm?.minimumGuarantee}
                                        handler={(value) => {
                                            if (/^\d{0,4}$/.test(value)) {
                                                configFormHandler("minimumGuarantee", value);
                                            }
                                        }}
                                        placeholder="Enter value"
                                        disabled={!isEditable}
                                        style={{ height: "47px", width: '220px' }}
                                    />
                                </div>

                                <AAutoComplete
                                    label="Concession *"
                                    placeholder="Select"
                                    currentValue={tempConfigForm?.concession}
                                    handleChange={(value) => configFormHandler("concession", value)}
                                    items={dropdowns?.concession || []}
                                    isMulti={false}
                                    isDisabled={!isEditable}
                                    style={{ control: { height: "47px", width: '220px' } }}
                                />

                                <AAutoComplete
                                    label="Map Course Ids *"
                                    placeholder="Select courses"
                                    currentValue={tempConfigForm?.mapCourseIds}
                                    handleChange={(value) => configFormHandler("mapCourseIds", value)}
                                    items={dropdowns?.mapCourseIds || []}
                                    isMulti={true}
                                    isDisabled={!isEditable}
                                    style={{ control: { height: "47px", width: '220px' } }}
                                    isShowCount={true}
                                />
                            </>
                        )}
                    </div>

                    {/* Footer Buttons */}
                    <div className="d-flex gap-2 m-3">
                        {(mode === "add" || mode === "edit") && (
                            <AButton variant="primary_filled" onClick={saveHandler}>
                                Save
                            </AButton>
                        )}

                        {/* {mode === "edit" && (
                        <AButton variant="danger" onClick={deleteHandler}>
                            Delete
                        </AButton>
                    )} */}
                    </div>
                </div>
            )}

            {/* Upload Modal */}
            <DocUploadModal
                open={isUploadOpen}
                setOpen={setIsUploadOpen}
                saveHandler={(s3Key, fileName) => {
                    setIsUploadOpen(false);
                    setTempConfigForm((prev) => ({
                        ...prev,
                        agreementFilePath: s3Key,
                        agreementFileName: fileName
                    }));
                }}
                acceptedFileTypes={[".pdf"]}
                maxUploadFileSize={5}
                serviceName={'PAYMENT_COLLECTION_ATTACHMENTS'}
                uniqueKeyParameter={"agreementCopy"}
                uploadedFileS3Key={tempConfigForm?.agreementFilePath}
                uploadedFileName={tempConfigForm?.agreementFileName}
                modalTitle={"Upload Agreement Copy"}
            />
        </Card>
    );
};

export default CourseMappingConfiguration;